import React, { useState } from "react";

import {
	ChevronDownIcon,
	ChangeableCheckbox,
} from "../../../../../resource/icons";

import Regions from "./regions.jsx";

const Company = ({ company }) => {
	const [companyOpened, setCompanyOpened] = useState(false);

	return (
		<div
			className={`company-branch ${
				companyOpened ? "company-branch-opened" : ""
			}`}
			onClick={() => {
				if (!companyOpened) {
					setCompanyOpened(true);
				}
			}}
		>
			<div
				className="branch"
				key={`branch-${company.companyId}`}
				onClick={() => setCompanyOpened(!companyOpened)}
			>
				<label
					onClick={(e) => {
						e.stopPropagation();
					}}
					className="checkbox-label"
				>
					<input
						type="checkbox"
						className="true-checkbox"
						checked={company.checked()}
						onChange={(e) => company.onSelectChange(e)}
					/>
					<ChangeableCheckbox
						indeterminateCheckBox={company.indeterminate()}
						checked={company.checked()}
						className="checkbox"
					/>
				</label>
				<span>{company.company}</span>
				<div className="spacer" />
				<ChevronDownIcon className={companyOpened && "chevron-opened"} />
			</div>
			{companyOpened && <Regions regions={company.regions} />}
		</div>
	);
};

export default Company;
